import { useEffect, type ReactNode } from 'react';
import { X } from 'lucide-react';

// Общая модалка: Escape закрывает, скролл body блокируется, на мобильном
// прилипает к низу экрана, на десктопе — по центру.

interface Props {
  title: string;
  children: ReactNode;
  onClose: () => void;
  wide?: boolean;
}

export default function Modal({ title, children, onClose, wide }: Props) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-50 flex items-end justify-center overflow-y-auto bg-ink/40 p-0 sm:items-center sm:px-4 sm:py-10"
      onClick={onClose}
    >
      <div
        className={`card relative w-full ${wide ? 'max-w-3xl' : 'max-w-md'} max-h-[92vh] overflow-y-auto p-5 shadow-lg sm:p-6`}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <button
          type="button"
          className="absolute right-3 top-3 p-1 text-ink/50 hover:text-ink"
          onClick={onClose}
          aria-label="Закрыть"
        >
          <X size={16} />
        </button>
        <h3 className="mb-4 text-[16px] font-medium tracking-tight">{title}</h3>
        {children}
      </div>
    </div>
  );
}
